const SvgHtmlPassing = (props) => {
    const content = props.content;
    const className = props.className;
    if (content.substr(0,20).includes("class")) {
      var parts = content.split(/(class="[^"]*")/);
      var newPart = parts[1].split(`"`);
      newPart[1] = `${newPart[1]} ${className}`;
      parts[1] = newPart.join(`"`);
      parts = parts.join("");
    }else{
      var parts = content.split("svg");
      parts[1] = `class="${className}" ${parts[1]}`;
      parts = parts.join("svg ");
    }
    return <div dangerouslySetInnerHTML={{ __html: parts }} />;
  };

export default SvgHtmlPassing;